(function() {
    'use strict';
 
a3_pilot_reports.filter('byCategory', byCategory);

    /**
    * @memberof PilotReports
    * @ngdoc filter
    * @name byCategory
    * @description 
    *   Filter questions by catecory and search text
    * @ngInject
    */
function byCategory() {
      return function (questions, obj) {
				var items = {
						category:obj.category,
						searchText: (obj.query) ? obj.query.toLowerCase():"",
						out: []
				};
				angular.forEach(questions, function (value, key) {
						if ((this.category === value.CategoryLabel) && (value.Label.toLowerCase().indexOf(this.searchText) >= 0 || value.Description.toLowerCase().indexOf(this.searchText) >= 0))  {
								this.out.push(value);
						}
				}, items);
				return items.out.dynamicSort('OrderNo');
			};
		};
		
 
 
 })();   